import { lazy, Suspense, useState, useRef, useEffect } from "react";
import "../styles/sections/AppStore.css"

import colorSharp from "../assets/img/color-sharp.png";
import grapgingCalcImg from "../assets/img/appIcons/grapging-calc2.webp";
import pythonIdeImg from "../assets/img/appIcons/python-ide.webp";
import sprintManagerImg from "../assets/img/appIcons/sprint-manager.webp";
import ImgConverterImg from "../assets/img/appIcons/img-converter.webp";
import McGameImg from "../assets/img/appIcons/mc-game1.webp";
import SnakeGamegImg from "../assets/img/appIcons/snake-game2.webp";
import QRCodeImg from "../assets/img/appIcons/QRCodeGen.webp"

const createLazyApp = (loader) => ({
  load: loader,
  Component: lazy(loader),
});

const APP_REGISTRY = [
  {
    name: "Image Converter",
    image: ImgConverterImg,
    ...createLazyApp(() => import("../apps/ImageConverter")),
  },
  {
    name: "QR Code Generator",
    image: QRCodeImg,
    ...createLazyApp(() => import("../apps/QRGen")),
  },
  {
    name: "Python IDE",
    image: pythonIdeImg,
    ...createLazyApp(() => import("../apps/PythonIde")),
  },
  {
    name: "Graphing Calculator",
    image: grapgingCalcImg,
    ...createLazyApp(() => import("../apps/GraphingCalc")),
  },
  {
    name: "Simple Sprint Manager",
    image: sprintManagerImg,
    ...createLazyApp(() => import("../apps/SprintManager")),
  },
  {
    name: "The Snake Game",
    image: SnakeGamegImg,
    ...createLazyApp(() => import("../apps/SnakeGame")),
  },
  {
    name: "Memory Card Game",
    image: McGameImg,
    ...createLazyApp(() => import("../apps/MemoryCardGame")),
  },
];

export const AppStore = () => {
  const [currentAppName, setCurrentAppName] = useState("");
  const appContainerRef = useRef(null); // Ref for the app container

  const selectedApp =
    APP_REGISTRY.find((appItem) => appItem.name === currentAppName) || null;

  const handleAppClick = (appName, appItemRef) => {
    if (currentAppName === appName) {
      setCurrentAppName("");
    } else {
      setCurrentAppName(appName);

      if (appItemRef) {
        appItemRef.focus();
      }
    }
  };

  const handleCloseApp = () => {
    setCurrentAppName("");
  };

  const handleMaximizeApp = () => {
    if (appContainerRef.current) {
      appContainerRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      appContainerRef.current.focus();
    }
  };

  useEffect(() => {
    if (selectedApp) {
      handleMaximizeApp();
    }
  }, [selectedApp]);

  return (
    <section id="app-store">
      <div className="container">
        <div className="appstore-bx">
          <h2>App Store</h2>
          <p>Welcome to my AppStore. Some practical tools. Some games. Instead of relying on external websites and dealing with ads, I created my own. Simple, functional, and ad-free.</p>
          <div className="appstore-grid">
            {APP_REGISTRY.map((appItem, index) => (
              <div
                className={`app-item ${currentAppName === appItem.name ? "selected" : ""}`}
                key={index}
                tabIndex="0"
                onMouseEnter={() => void appItem.load()}
                onFocus={() => void appItem.load()}
                onClick={(e) => handleAppClick(appItem.name, e.currentTarget)}
              >
                <img src={appItem.image} alt={appItem.name} />
                <h5>{appItem.name}</h5>
              </div>
            ))}
          </div>
        </div>
      </div>
      <img className="background-image-left" src={colorSharp} alt="Background" />
      {selectedApp && (
        <div>
          <div
            ref={appContainerRef}
            style={{ height: "5px", outline: "none" }}
          ></div>
          <div className="app-container">
            <div className="macos-titlebar">
              <div className="macos-buttons">
                <button
                  className="macos-button macos-close-button"
                  onClick={handleCloseApp}
                  title="Close"
                >
                  <span></span>
                </button>
                <button
                  className="macos-button macos-minimize-button"
                  onClick={handleCloseApp}
                  title="Minimize"
                >
                  <span></span>
                </button>
                <button
                  className="macos-button macos-maximize-button"
                  onClick={handleMaximizeApp}
                  title="Maximize"
                >
                  <span></span>
                </button>
              </div>
            </div>
            <Suspense
              fallback={
                <div className="app-loading-state">
                  Loading {selectedApp.name}...
                </div>
              }
            >
              <selectedApp.Component />
            </Suspense>
          </div>
        </div>
      )}
    </section>
  );
};
